export default {
  app: {
    tradeOffers: {
      country: 'País',
      loginPrompt: 'Si quieres ver las ofertas comerciales, debes {0}.',
      logIn: 'iniciar sesión',
    },
  },
};
